/* eslint-disable jsx-a11y/anchor-is-valid */


import React, { useState, useEffect,useRef, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import '../../assets/styles/login.scss'
import i18next from "i18next";
import { useTranslation } from 'react-i18next';
import { languages } from '../../utils/languages';
import {passwordResetError} from '../../utils/configs';
import { fetchUserPermissions, fetchCulture,storageUtil,parseJwtToken, emailRegex} from '../../utils/commonFunctions';
import { themesList, setTheme, DEFAULT_THEME_INDEX } from '../../utils/themes';
import PasswordValidator from '../../common/PasswordValidation';
import UserSession from '../../utils/userSessionClass';
import francelang from '../../assets/france.svg';
import spainlang from '../../assets/spainlang.svg';
import uaelang from '../../assets/uaelang.svg';
import usercog from '../../assets/usercog.svg';
import usercogDim from '../../assets/usercogDim.svg';
import mail from "../../assets/mail.svg";
import userCogAct from "../../assets/usercogAct.svg";
import userDark from "../../assets/userDark.svg";
import userLight from "../../assets/userLight.svg";

import user from '../../assets/user.svg';
import sun from '../../assets/sun.svg';
import moon from '../../assets/moon.svg';
import sundim from '../../assets/sundim.svg';
import moondim from '../../assets/moondim.svg';
import chevrondown from '../../assets/chevrondown.svg';
import lock from '../../assets/lock.svg';
import user2log from '../../assets/user2log.svg';
import ngologo from '../../assets/ngologo.png';
import { EmployeeEndpoint, UserEndpoint} from "../../utils/axios";
import { Footer } from '../../common';
import {ThemeContext} from "../../contexts/themeContext";
import LoadingGIF from '../../assets/loadingIn.gif';
import { FiEye,  FiEyeOff } from "react-icons/fi";

/**
 * Icons
 */
import enlang from '../../assets/enlang.svg';

export default function Login() {
  const { t ,ready} = useTranslation();
  const navigate = useNavigate()
  const userSession = new UserSession();

  const [themeClassObj, setThemeClassObj] = React.useState(themesList[DEFAULT_THEME_INDEX]);
  const [username, setUsername] = useState('')
  const [domain] = useState(process.env.REACT_APP_ACCOUNT_DOMAIN)
  const [loginMessage, setLoginMessage] = useState({text:""})
  const [password, setPassword] = useState('')
  const [passwordResetPrompt,setPasswordResetPrompt]=useState("");
  const [updatePassword,setUpdatePassword]=useState({currentPassword:"",newPassword:"",confirmPassword:""});
  const [validatePasswordUpdate,setValidatePasswordUpdate]=useState(true);
  const [passwordMatch,setPasswordMatch]=useState(false);
  const [showPass, setshowPass] = useState({ default: false, currentPassword: false, newPassword: false, confirmPassword: false });
  const [adminLogin, setAdminLogin] = useState(false)
  const [isLoggingIn, setisLoggingIn] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const [forgotPasswordErrors, setForgotPasswordErrors] = useState({ email: '' });
  const [forgotPasswordAPIResp, setForgotPasswordAPIResp] = useState({ isExecuted: false, success: false, message: '' });
  const clearMsgTimer = useRef(null);
  const {updateTheme} = useContext(ThemeContext);

  React.useEffect(() => {
    /**
     * Set title
     */
    document.title = t(`company.productName`) + ' ' + t(`pages.login`);

  }, [t,ready]);

   React.useEffect(() => {
      setLoginMessage({text:""});
      setPasswordResetPrompt("");
      setUpdatePassword({currentPassword:"",newPassword:"",confirmPassword:""});
  }, [username,domain,password,adminLogin]);

    React.useEffect(() => {
  setshowPass(false);
  }, [adminLogin]);

  React.useEffect(() => {
    setLoginMessage({text:''});
}, [updatePassword]);

  React.useEffect(() => {
    setForgotPasswordEmail('');
    setForgotPasswordErrors({ email: '' });
    setForgotPasswordAPIResp({ isExecuted: false, success: false, message: '' });
  }, [adminLogin]);

useEffect(() => {
  if (forgotPasswordEmail.length && !emailRegex.test(forgotPasswordEmail) && adminLogin) {
    setForgotPasswordErrors(prev => ({...prev,email: 'E-mail is invalid!'}));
  } else {
    setForgotPasswordErrors(prev => ({...prev,email: ''}));
  }
}, [forgotPasswordEmail, adminLogin]);

  async function fetchTieZone() {
    try {
      const res = await fetchCulture();
      if(res?.timezone){
        return res;
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  const currentLanguageCode = i18next.language || 'en'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  useEffect(() => {
    document.body.dir = currentLanguage.dir || 'ltr'
  }, [currentLanguage, t])

 function resetMessages(tOut=3500,type=false){
  if(clearMsgTimer.current){
    clearTimeout(clearMsgTimer.current);
  }
  clearMsgTimer.current= setTimeout(()=>{
setLoginMessage({text:''})
if(type){
  setPasswordResetPrompt("");
  setPassword("");
  setUpdatePassword({currentPassword:"",newPassword:"",confirmPassword:""});
}
  },tOut)
  return clearMsgTimer.current;
}


  React.useEffect(() => {
    document.body.dir = currentLanguage.dir || 'ltr'
  }, [currentLanguage, t]);

  React.useEffect(() => {
    let theme = themeClassObj;
    if (localStorage.getItem('theme') && typeof localStorage.getItem('theme') === 'object') {
      theme = JSON.parse(localStorage.getItem('theme'));
    }

    setUserTheme(theme);
  }, [themeClassObj]);

  const setUserTheme = (theme = themesList[0]) => {
    setThemeClassObj(theme);
    setTheme(theme);
  };

  const setPermissions=(perArr,userType,userName)=>{
    const permissions = {};
    perArr.forEach(item => {
        const { resource, action } = item;
        if (!permissions[`${userType}-role`]) {
            permissions[`${userType}-role`] = {
                "role": [userName, `${userType}-role`],
            };
        }
        if (permissions[`${userType}-role`][action]) {
            permissions[`${userType}-role`][action].push(resource);
        } else {
            permissions[`${userType}-role`][action] = [resource];
        }
    });
  if(permissions){
    localStorage.setItem('userPermissions', JSON.stringify(permissions));
    localStorage.setItem('userRole', `${userType}-role`);
  }
  }


const onLoginPress = async (mode) => {
  setisLoggingIn(true);
  updateTheme();
  setLoginMessage({text:""});
  const isAdmin = adminLogin;
  let axObj;
  let body={};
  if(mode==='login'){
  axObj = UserEndpoint.setHost();
  body = isAdmin
    ? { admin: true, username, password }
    : { clientName: domain, employee: true, username, password };
  storageUtil.set('domain',domain,'local');
  localStorage.setItem('sType', username);

  try {
    const userResp = await axObj.postWithFullResp('idpLogin', body);
    const { data, headers } = userResp || {};
    if (!data || !headers) throw new Error("Invalid response");

    localStorage.setItem('login_credentials', JSON.stringify({ data, headers }));
    localStorage.setItem('token', headers['x-csrf-token']);

    const tokenResp = await parseJwtToken(data);

    if (!tokenResp) throw new Error("Empty token");

    const user = data;
    const userType = tokenResp.userType ?? undefined;
    const userName = tokenResp.userName ?? undefined;
    const userId = tokenResp.userId ?? undefined;
    const employeeId = tokenResp.identity ? tokenResp.identity:userType==='admin'?userId:userName;
    
    storageUtil.set('employeeId',employeeId,'local');
    storageUtil.set('userType',userType,'local');

    const roleName = `${userType}-role`;
    const permissionsResp = await fetchUserPermissions({ ...userResp, ...tokenResp }, { subject: userName, roleName });

    if (permissionsResp?.items?.length) {
      setPermissions(permissionsResp.items, userType, userName);
    }

    const themeToApply = themesList.find(t => t.keyname === user.theme?.keyname) || themesList[0];
    setUserTheme(themeToApply);
    user.theme = themeToApply;

    const resTimeZone = await fetchTieZone();
    if(resTimeZone){
    localStorage.setItem("NGO_CULTURE",JSON.stringify(resTimeZone));
    }

    userSession.setSession({ ...user, ...tokenResp });

    navigate('/');
  } catch (error) {
    console.error('Login error:', error);
    let erMsg = 'Login Error!';
    try {
      let parsedError = JSON.parse(error.message);
      setPasswordResetPrompt(parsedError.data?.code??"");
      erMsg = parsedError?.data?.msg || parsedError?.data?.message || erMsg;
    } catch (_) {}
    setLoginMessage({error:erMsg});
  } finally {
    resetMessages(3500,false);
    setisLoggingIn(false);
  }
}else{
  axObj = EmployeeEndpoint.setHost();
  body ={
    username,
    clientName:domain,
    currentPassword: updatePassword.currentPassword,
    newPassword:  updatePassword.newPassword,
    confirmPassword: updatePassword.confirmPassword,
    isValidPassword: true
};

  try {
    const userResp = await axObj.postWithFullResp('updatePassword', body);
    if(userResp?.status===200){
      const msg = userResp.data?.msg || userResp.data?.message || "Password updated successfully. Please login with new password.";
      setLoginMessage({text:msg});
      resetMessages(2500,true);
    }
  } catch (error) {
    console.error('Login error:', error);
    let erMsg = 'Update Password Error!';
    try {
      let parsedError = JSON.parse(error.message);
      erMsg = parsedError?.data?.msg || parsedError?.data?.message || erMsg;
    } catch (_) {}
    setLoginMessage({error:erMsg});
    resetMessages(3500,false);
  } finally {
    setisLoggingIn(false);
  }
}

};



const showLanguageIcon = (langCode) => {
  switch (langCode) {
    case 'en':
      return <img alt='en' width={'25px'} height={'25px'} src={enlang} />
    case 'fr':
      return <img alt='fr' width={'25px'} height={'25px'} src={francelang} />
    case 'es':
    case 'sp':
      return <img alt='es' width={'25px'} height={'25px'} src={spainlang} />
    case 'ar':
      return <img alt='ar' width={'25px'} height={'25px'} src={uaelang} />
    default:
      return <img alt='en' width={'25px'} height={'25px'} src={enlang} />
  }
}

  const handleForgotPassword = (e) => {
    setShowForgotPassword(true);
    setForgotPasswordEmail('');
    setForgotPasswordErrors({ email: '' });
    setForgotPasswordAPIResp({ isExecuted: false, success: false, message: '' });
  }

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
    setForgotPasswordEmail('');
    setForgotPasswordErrors({ email: '' });
    setForgotPasswordAPIResp({ isExecuted: false, success: false, message: '' });
  };

  const onForgotPasswordEmailChange = (e) => {
    setForgotPasswordEmail(e.target.value);
    setForgotPasswordAPIResp({ isExecuted: false, success: false, message: '' });

    if (!e.target.value) {
      setForgotPasswordErrors({...forgotPasswordErrors, email: adminLogin ? 'Enter email' : 'Enter employee code'});
    } else {
      setForgotPasswordErrors({...forgotPasswordErrors, email: ''});
    }
  };

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    setForgotPasswordAPIResp({ isExecuted: false, success: false, message: '' });

    if (!forgotPasswordEmail) {
      setForgotPasswordErrors({...forgotPasswordErrors, email: adminLogin ? 'Enter email' : 'Enter employee code'});
      return false;
    } else if (adminLogin) {
      if (!emailRegex.test(forgotPasswordEmail)) {
        setForgotPasswordErrors({...forgotPasswordErrors, email: 'E-mail is invalid!'});
        return;
      }
    }

    const payload = {
      username: forgotPasswordEmail
    };

    setisLoggingIn(true);
    const Domain = adminLogin ? UserEndpoint : EmployeeEndpoint;
    const url = adminLogin ? 'password/reset' : 'resetPassword';
    
    await Domain.post(url, payload)
      .then((resp) => {
        setisLoggingIn(false);
        setForgotPasswordAPIResp({ 
          isExecuted: true, 
          success: true, 
          message: resp?.msg || resp?.message || 'We have sent reset password details to your registered email.' 
        });
        setTimeout(() => {
          handleBackToLogin();
        }, 2500);
      })
      .catch((err) => {
        setisLoggingIn(false);
        let statusObj = JSON.parse(err.message);
        let msg = 'Error occurred while submitting your request.';
        if (statusObj.status === 400) {
          msg = statusObj.data?.msg || statusObj.data?.message;
        }
        setForgotPasswordAPIResp({ isExecuted: true, success: false, message: msg });
      });

    return false;
  };

  const togglePassVisibility = (multiInput = "") => {
    if (!multiInput.length) {
      toggleBooleanPassVisibility();
    } else {
      toggleObjectPassVisibility(multiInput);
    }
  }

  const toggleBooleanPassVisibility = () => {
    setshowPass(!showPass);
  }

  const toggleObjectPassVisibility = (multiInput) => {
    setshowPass((prevState) => ({
      ...prevState,
      [multiInput]: !prevState[multiInput] ?? false,
    }));
  }

  const getUserTabIcon = () => {
  if (!adminLogin) {
    return user;
  } else {
    return themeClassObj?.title === 'Dark' ? userLight : userDark;
  }
};

const getAdminTabIcon = () => {
  if (adminLogin) {
    return userCogAct;
  }
  return themeClassObj?.title === 'Dark' ? usercog : usercogDim;
};

  return (
    <>
    <div className='flexRow'>
      <div className='login-bg height100 width50 flexRow justifyContentCenter alignItemsCenter'>
        <Footer mode={"opened"}/>
      </div>
      <div className={`height100 width50 flexRow justifyContentCenter alignItemsCenter right-block ${themeClassObj?.title === 'Dark' ? 'light-themebg' : 'dark-themebg'}`}>
        <div className='flexRow justifyContentFlexEnd alignItemsCenter login-header'>
          <div className="dropdown dropdown-style1">
          <button
            className='btn btn-link dropdown-toggle language-selector'
            type="button"
            title={t('pages.loginContent.select-language')}
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {/* {showLanguageIcon(currentLanguage.country_code)} */}
            <span className='language-text'>{t(`languageNames.${currentLanguage.country_code}`)}</span>
            <span className="language-divider" />

<span className="language-chevron">
                  <img src={chevrondown} className="" alt="Logo" />
</span>
          </button>
          <ul className={`dropdown-menu padding0 minWidth0-lang ${themeClassObj?.title === 'Dark' ? 'dropdown-dark' : ''}`} aria-labelledby="dropdownMenuButton1">
            {languages.map(({ code, name, country_code }) => (
              <li key={country_code}
                onClick={() => {
                    i18next.changeLanguage(code);
                }}>
                  <p   className={`dropdown-item margBottom0 ${currentLanguage.country_code === code ? 'body-text-extrabold active' : ''}`} >
                    <span className='flexRow alignItemsCenter'>{showLanguageIcon(code)}&nbsp;&nbsp;{t(`languageNames.${code}`)}</span>
                  </p>
              </li>
            ))}
          </ul>



        </div>
          <button
          className={`theme-toggle ${themeClassObj?.title === 'Dark' ? 'light' : 'dark'}`}
          type="button"
            title={t('pages.loginContent.switch-theme')}
          aria-label={t('pages.loginContent.select-theme')}
          onClick={() => {
          const currentIndex = themesList.findIndex(
          t => t.title === themeClassObj.title
          );
          const nextIndex = (currentIndex + 1) % themesList.length;
          setUserTheme(themesList[nextIndex]);
          }}
          >
          <span className="theme-option sun">
          <img src={themeClassObj?.title === 'Dark' ? sun : sundim} alt="Light theme" />
          </span>

          <span className="theme-option moon">
          <img  src={themeClassObj?.title === 'Dark' ? moondim : moon} alt="Dark theme" />
          </span>
          </button>
        </div>

        <div className='login-container'>

          {/* Logo */}
          <div className="login-header-stack">
            <div className="logo-box">
                  <img src={ngologo} className="login-logo" alt="Logo" />
            </div>

          <h2 className='flexRow justifyContentCenter welcome-text'>{t('pages.loginContent.welcomebackMessage')}</h2>
          </div>
          {!showForgotPassword ? (
            <>
            <div className="login-tabs">
          <button
            className={`tab-login ${!adminLogin ? 'active' : ''}`}
            onClick={() => setAdminLogin(false)}
          >
            <img src={getUserTabIcon()} className="tab-login-icon" alt="User Login" />
            {t('pages.userLogin')}
          </button>

          <button
            className={`tab-login ${adminLogin ? 'active' : ''}`}
            onClick={() => setAdminLogin(true)}
          >
            <img src={getAdminTabIcon()} className="tab-login-icon" alt="Admin Login" />
            {t('pages.adminLogin')}
          </button>
          </div>

          <div className="margBottom24">
            {passwordResetPrompt !== passwordResetError ? (
              <>
                <div className='form-group-login'>
                  <label className='form-label'>{!adminLogin ? t('pages.loginContent.userId'):t('pages.loginContent.adminUserId')}</label>
                  <div className='input-wrapper'>
                           <img src={user2log} className="input-icon" alt="Logo" />

                    <input
                      onChange={e => setUsername(e.target.value)}
                      value={username}
                      type='text'
                      className='form-input'
                      placeholder={!adminLogin ? t('pages.loginContent.placeHolderUserId'):t('pages.loginContent.placeHolderAdminUserId')}
                    />
                  </div>
                </div>

                <div className='form-group'>
                  <div className='flexRow justifyContentSpaceBetween'>
                    <label className='form-label'>{t('pages.loginContent.password')}</label>
                    <span
                      className='forgot-password-link'
                      onClick={handleForgotPassword}
                    >
                     {t('pages.loginContent.forgotPassword')}
                    </span>
                  </div>
                  <div className='input-wrapper'>
                           <img src={lock} className="input-icon" alt="Logo" />
                    <input
                      onChange={e => setPassword(e.target.value)}
                      type={showPass ? "text" : "password"}
                      value={password}
                      className='form-input'
                      placeholder={t('pages.loginContent.placeHolderPassword')}
                    />
                    <button 
                      onClick={() => togglePassVisibility("")} 
                      className='password-toggle'
                      type='button'
                    >
                      {!showPass ? <FiEyeOff size={20}/> : <FiEye size={20}/>}
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className='flexRow alignItemsCenter textAlignLeft sector-origin-m'>
                  {t('pages.loginContent.passwordUpdateWarning')}
                </div>
                {Object.keys(updatePassword).length > 0 && (
                  <PasswordValidator 
                    passwordMatchError={setPasswordMatch} 
                    showValidation={validatePasswordUpdate} 
                    empPassword={false} 
                    isValidPassword={setValidatePasswordUpdate} 
                    passwordFields={updatePassword}
                  />
                )}
                
                <div className='form-group margBottom24'>
                  <label className='form-label'>{t('pages.loginContent.currentPassword')}</label>
                  <div className='input-wrapper'>
                  <img src={lock} className="input-icon" alt="Logo" />
                    <input
                      onChange={e => setUpdatePassword((_) => ({..._, currentPassword: e.target.value}))}
                      type={showPass.currentPassword ? "text" : "password"}
                      placeholder={t('pages.loginContent.currentPassword')}
                      value={updatePassword.currentPassword}
                      className='form-input'
                    />
                    <button 
                      onClick={() => togglePassVisibility('currentPassword')} 
                      className='password-toggle'
                      type='button'
                    >
                      {!showPass.currentPassword ? <FiEyeOff size={20}/> : <FiEye size={20}/>}
                    </button>
                  </div>
                </div>

                <div className='form-group margBottom24'>
                  <label className='form-label'>{t('pages.loginContent.newPassword')}</label>
                  <div className='input-wrapper'>
                    <img src={lock} className="input-icon" alt="Logo" />
                    <input
                      onChange={e => setUpdatePassword((_) => ({..._, newPassword: e.target.value}))}
                      type={showPass.newPassword ? "text" : "password"}
                      value={updatePassword.newPassword}
                      placeholder={t('pages.loginContent.newPassword')}
                      className='form-input'
                    />
                    <button 
                      onClick={() => togglePassVisibility('newPassword')} 
                      className='password-toggle'
                      type='button'
                    >
                      {!showPass.newPassword ? <FiEyeOff size={20}/> : <FiEye size={20}/>}
                    </button>
                  </div>
                  {passwordMatch && (
                    <h6 className="small-body-text-regular-label-upload text-danger">
                      {t('warningTexts.passwordMatchUpdate')}
                    </h6>
                  )}
                </div>

                <div className='form-group margBottom24'>
                  <label className='form-label'>{t('pages.loginContent.confirmPassword')}</label>
                  <div className='input-wrapper'>
                  <img src={lock} className="input-icon" alt="Logo" />
                    <input
                      onChange={e => setUpdatePassword((_) => ({..._, confirmPassword: e.target.value}))}
                      type={showPass.confirmPassword ? "text" : "password"}
                      value={updatePassword.confirmPassword}
                      placeholder={t('pages.loginContent.confirmPassword')}
                      className='form-input'
                    />
                    <button 
                      onClick={() => togglePassVisibility('confirmPassword')} 
                      className='password-toggle'
                      type='button'
                    >
                      {!showPass.confirmPassword ? <FiEyeOff size={20}/> : <FiEye size={20}/>}
                    </button>
                  </div>
                  {passwordMatch && (
                    <h6 className="small-body-text-regular-label-upload text-danger">
                      {t('warningTexts.passwordMatchUpdate')}
                    </h6>
                  )}
                </div>
              </>
            )}
          </div>

          {/* Sign In Button */}
          <div className='button-container'>
            {passwordResetPrompt !== passwordResetError ? (
              <button
                disabled={!(username && password) || isLoggingIn}
                className='sign-in-button'
                onClick={() => onLoginPress("login")}
              >
                {!isLoggingIn ? (
                  t('pages.loginContent.signIn')
                ) : (
                  <img src={LoadingGIF} className="loading-icon" alt="Loading" />
                )}
              </button>
            ) : (
              <button
                disabled={validatePasswordUpdate || isLoggingIn}
                className='sign-in-button'
                onClick={() => onLoginPress("update")}
              >
                {!isLoggingIn ? (
                  t('pages.loginContent.updatePassword')
                ) : (
                  <img src={LoadingGIF} className="loading-icon" alt="Loading" />
                )}
              </button>
            )}
            
            {(loginMessage.text?.length || loginMessage.error?.length) && (
              <div className={`flexRow confirmation_popup_login ${loginMessage.error ? 'alert_error' : 'alert_success'}`}>
                <h6 className="subheading-text-medium-title fontLight">
                  {loginMessage.text || loginMessage.error}
                </h6>
              </div>
            )}
   
          </div>
          </>
          ) : (
            <>
  {/* Forgot password mode */}
              <form onSubmit={handleForgotPasswordSubmit}>
                <div className='form-group-login'>
                  <label className='form-label'>
                    {adminLogin ? t('pages.loginContent.forgotPasswordDg.enterUserEmailAdmin') : t('pages.loginContent.forgotPasswordDg.enterEmployeeCode')}
                  </label>
                  <div className='input-wrapper'>
                    <img src={adminLogin? mail : user2log} className="input-icon" alt="Logo" />
                    <input
                      type='text'
                      className='form-input'
                      placeholder={adminLogin ? t('pages.loginContent.forgotPasswordDg.titleAdmin') : t('pages.loginContent.forgotPasswordDg.titleEmployee')}
                      value={forgotPasswordEmail}
                      onChange={onForgotPasswordEmailChange}
                    />
                  </div>
                  {forgotPasswordErrors.email && (
                    <div className='validationMsgDiv error' style={{ color: '#ef4444', fontSize: '14px', marginTop: '4px' }}>
                      {forgotPasswordErrors.email}
                    </div>
                  )}
                </div>

                {forgotPasswordAPIResp.isExecuted && (
                  <div className={`flexRow confirmation_popup_login ${forgotPasswordAPIResp.success ? 'alert_success' : 'alert_error'}`} style={{ marginTop: '16px' }}>
                    <h6 className="subheading-text-medium-title fontLight">
                      {forgotPasswordAPIResp.message}
                    </h6>
                  </div>
                )}

                <div className='button-container-forgot-password'>
                  <button
                    type='submit'
                    disabled={!forgotPasswordEmail || isLoggingIn}
                    className='sign-in-button'
                  >
                    {!isLoggingIn ? (
                      t('buttons.resetPassword') 
                    ) : (
                      <img src={LoadingGIF} className="loading-icon" alt="Loading" />
                    )}
                  </button>

              <span className="flexRow textAlignCenter justifyContentCenter">
                <span
                  role="button"
                  tabIndex={0}
                  className="back-to-login-text"
                  onClick={handleBackToLogin}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleBackToLogin();
                    }
                  }}
                >
                  {t('pages.loginContent.backToLogin')}
                </span>
              </span>

                </div>
              </form>
            </>
          )}
        </div>
      </div>
      {!ready && <div className='overlay_hide sub'></div>}
    </div>
    </>
  )
}
